import "core-js/modules/es.string.match";
import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(termsOnEnter);

import { call } from 'redux-saga/effects';
import { COUNTRY_CODE_TO_NAME } from 'constants/countries-served';
import { selectCountry } from 'redux/modules/locale';
export function termsOnEnter(store, _ref, replaceState) {
  var location, countryCode;
  return regeneratorRuntime.wrap(function termsOnEnter$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          location = _ref.location;

          if (!location.pathname.match(/terms\/?$/)) {
            _context.next = 7;
            break;
          }

          countryCode = selectCountry(store.getState()); // Only redirect if it's for an active country code

          if (!(countryCode in COUNTRY_CODE_TO_NAME)) {
            _context.next = 7;
            break;
          }

          _context.next = 6;
          return call(replaceState, "/terms/".concat(countryCode.toLowerCase()));

        case 6:
          return _context.abrupt("return", _context.sent);

        case 7:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}